import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {config} from '../../common/config/config';
import {
    constance,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {Route, Routes, useNavigate} from 'react-router-dom';
import NoteBoxSendNote from "./NoteBoxSendNote";
import NoteBoxContent from "./NoteBoxContent";

let noteBox: any = config.noteBox;
export default function NoteBox() {
    console.log('NoteBox');
    const [state, setState] = useState<any>({});
    let {id, workplace, no, page, club, department, keyword, searchType} = common.getQuery();

    const navigate = useNavigate();

    function handleMovePage(value: any) {
        navigate(`${config.url.noteBox}/${value.id}`);
    }

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: 4,
                    mb: 2,
                }}>
                    <Box sx={{
                        display: 'flex',
                        width: 1,
                        borderTop: styles.border,
                        borderTopWidth: '3px',
                        borderBottom: styles.border,
                        backgroundColor: 'var(--scc-surface-muted)',
                    }}>
                        {
                            Object.keys(config.noteBox).map((key, index) => {
                                let value = noteBox[key];
                                console.log(value);
                                let key2 = window.location.pathname.split('/')[2];
                                return (
                                    <Box key={index}
                                         onClick={() => handleMovePage(value)}
                                         sx={{
                                             width: {xs: 1 / Object.keys(config.noteBox).length, sm: 1 / Object.keys(config.noteBox).length},
                                             p: 1,
                                             // mt: 1, mb: 1,
                                             borderRight: styles.border,
                                             cursor: 'pointer',
                                             background: key2 == key? '#696969' :'',
                                             transition: 'all ease-out 0.3s',
                                         }}>
                                        <Typography align={'center'} variant={"subtitle1"} sx={{color: key2 == key? '#fff' :''}}>
                                            {value.text}
                                        </Typography>
                                    </Box>
                                )
                            })
                        }
                    </Box>
                    <Routes>
                        <Route path={'/send-note'} element={<NoteBoxSendNote/>}/>
                        <Route path={`/${constance.noteType.inBox}`} element={<NoteBoxContent id={constance.noteType.inBox}/>}/>
                        <Route path={`/${constance.noteType.sentInbox}`} element={<NoteBoxContent id={constance.noteType.sentInbox}/>}/>
                    </Routes>
                </Stack>
            </Box>
        </>
    );
}
